import Icon from "@material-ui/icons/SupervisedUserCircle";
import CommercialDocumentCreate from "./CommercialDocumentCreate";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "commercialDocuments",
  create: CommercialDocumentCreate,
  icon: Icon,
};
